const maxByKey = (arr, key) => arr.reduce((max, obj) => (Number(obj[key]) > max ? Number(obj[key]) : max), arr[0][key]);

export const getIncrementValueByKey = (array, key) => Number.parseInt(maxByKey(array, key) || 0, 10) + 1;
